import { NewsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$state', '$http', '$stateParams', '$sce', '$translate'];

/**
 * @ngdoc service
 * @name controllers.News
 *
 * @description
 * News controller
 */
let _$scope;
let _$http;
let _$sce;
let languages = {};
const lang = CWCONFIG.language;
let parsedBookmarks;
let bookmarkStatus;
let _$translate;
const callUrl = CWCONFIG.news.getUrl;
class Article {

    constructor($scope, $state, $http, $stateParams, $sce, $translate) {

        const blogLanguages = CWCONFIG.news.languages;
        const isAvailable = blogLanguages.find(language => language === lang);
        if (!isAvailable) {

            $state.go('root.dashboard.home');
            return false;

        }

        /**
         * Check if how-to category is avalable, if not set threats category default
         */
        const availableCategory = 'how-to';

        /**
         * Check if blog language was updated
         */

        if (localStorage.getItem('news_language')) {

            if (lang !== localStorage.getItem('news_language')) {

                localStorage.setItem('news_language', lang);

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1',
                });

                return false;

            }

        } else {

            localStorage.setItem('news_language', lang);

        }

        languages = {
            en: {
                threats: 2,
                'how-to': 2282,
            },
            de: {
                threats: 2,
                'how-to': 1214,
            },
            fr: {
                threats: 2,
                'how-to': 2300,
            },
            es: {
                threats: 2,
                'how-to': 6858,
            },
            it: {
                threats: 2,
                'how-to': 2300,
            },
            'pt-br': {
                threats: 2,
                'how-to': 6858,
            },
        };

        _$scope = $scope;
        _$http = $http;
        _$sce = $sce;
        _$scope.currentCategory = $state.params.tab;
        _$translate = $translate;
        _$scope.postcontent = [];
        _$scope.currentPages = NewsRepository.getPageNumber();
        _$scope.currentLanguage = lang;

        parsedBookmarks = JSON.parse(localStorage.getItem('bookmarks'));
        _$scope.availableCategories = languages[lang];
        const articleId = $stateParams.id;
        _$scope.articleId = $stateParams.id;
        const newsList = NewsRepository.getAll();
        bookmarkStatus = this.checkIfArticleIsSaved($stateParams.id);

        if (newsList.length) {

            let found = false;

            newsList.forEach((item) => {

                if (item) {

                    Object.keys(item).forEach((category) => {

                        item[category].forEach((article) => {

                            if (article.id === parseInt(articleId, 0)) {

                                $scope.currentArticle = article;
                                $scope.trustedHtmlContent
                                    = $sce.trustAsHtml(article.content.rendered);
                                this.setArticleCategory();
                                found = true;
                                this.calculateTimeToRead(article.content.rendered.replace(/<(?:.|\n)*?>/gm, ''));
                                this.updateLazyLoadResources();

                            }

                        });

                    });

                }

            });

            if (found === false) {

                this.articleRequest(articleId);
                _$scope.isLoading = true;

            }

        } else {

            this.articleRequest(articleId);
            _$scope.isLoading = true;

        }

        if (bookmarkStatus) {

            _$scope.bookmarkStatus = true;

        }

        if (bookmarkStatus === undefined) {

            _$scope.bookmarkStatus = false;

        }

        Mixpanel.send('ConnectWeb News Article Open');

    }

    /**
     * Get the article by id
     * param @string
     */
    articleRequest(articleId) {

        _$http({

            method: 'GET',
            url: `${callUrl}/${articleId}?_embed`,

        }).then((response) => {

            _$scope.currentArticle = response.data;
            _$scope.trustedHtmlContent = _$sce.trustAsHtml(response.data.content.rendered);
            this.calculateTimeToRead(response.data.content.rendered.replace(/<(?:.|\n)*?>/gm, ''));
            const date = response.data.date.split('T');
            [response.data.date] = date;
            this.setArticleCategory();
            _$scope.isLoading = false;
            this.updateLazyLoadResources();

        });

    }

    /**
     * Calculate time to read
     * param @object
     */
    calculateTimeToRead(content) {

        const wordsPerMinute = 200;

        const textLength = content.split(' ').length;

        if (textLength > 0) {

            const value = Math.ceil(textLength / wordsPerMinute);

            _$scope.timeToRead = value;

        }

    }

    /**
     * Check if article is bookmarked
     * param @string
     */
    checkIfArticleIsSaved(articleId) {

        bookmarkStatus = parsedBookmarks[lang].find(element => element === parseInt(articleId, 0));
        return bookmarkStatus;

    }

    /**
     * Save article in bookmarks list
     * param @string
     */
    saveArticle(articleId) {

        if (_$scope.bookmarkStatus === false) {

            parsedBookmarks[lang].push(parseInt(articleId, 0));
            localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
            this.getSavedArticle(articleId);
            _$scope.bookmarkStatus = true;

            Mixpanel.send('ConnectWeb News Bookmark Click', {
                Bookmark: 'Save',
            });

        }

    }

    /**
     * Remove article from bookmarks list
     * param @string
     */
    removeArticle(articleId) {

        if (_$scope.bookmarkStatus === true) {

            parsedBookmarks[lang].forEach((localStorageItem) => {

                if (localStorageItem === parseInt(articleId, 0)) {

                    const remove = function remove(array, element) {

                        return array.filter(el => el !== element);

                    };

                    parsedBookmarks[lang] = remove(parsedBookmarks[lang], localStorageItem);
                    localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                    NewsRepository.deleteBookmark(parseInt(articleId, 0), lang);
                    _$scope.bookmarkStatus = false;

                }

            });

            Mixpanel.send('ConnectWeb News Bookmark Click', {
                Bookmark: 'Unsave',
            });

        }

    }

    /**
     * Update bookmarks repo
     * param @string
     */
    getSavedArticle(articleId) {

        _$http({

            method: 'GET',
            url: `${callUrl}/${articleId}`,

        }).then((response) => {

            NewsRepository.addBookmark(response.data, lang);
            this.getShortDescriptionSingleArticle(response.data);

        });

    }

    getShortDescriptionSingleArticle(data) {

        data.shortDescription = data.excerpt.rendered
            .split('</p>')[0].replace(/(<([^>]+)>)/ig, '').substr(0, 300);

    }

    updateLazyLoadResources() {

        setTimeout(() => {

            angular.forEach(angular.element('.article-body img'), (value) => {

                const imageUrl = angular.element(value).attr('data-src');
                if (imageUrl) {

                    angular.element(value).removeAttr('src');
                    angular.element(value).attr('src', imageUrl);

                }

            });

            angular.forEach(angular.element('.article-body iframe'), (value) => {

                let iframeUrl = angular.element(value).attr('data-src');

                if (!iframeUrl) {

                    iframeUrl = angular.element(value).attr('src');

                }
                const linkVideo = angular.element(`<a class="external-link" href="${iframeUrl}" target="_blank">${_$translate.instant('cw.news.see_video_here')}</a>`);
                linkVideo.insertAfter(angular.element(value));
                angular.element(value).remove();

            });

        }, 0);

    }

    setArticleCategory() {

        if (_$scope.currentCategory === 'bookmarks') {

            _$scope.currentCategoryName = _$translate.instant('cw.news.category_name.bookmarks');

        } else if (_$scope.currentCategory === 'threats') {

            _$scope.currentCategoryName = _$translate.instant('cw.news.category_name.threats');

        } else if (_$scope.currentCategory === 'how-to') {

            _$scope.currentCategoryName = _$translate.instant('cw.news.category_name.how_to');

        }

    }

}

_serviceDependencies.push(Article);

angular.module('controllers')
    .controller('Article', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/news/article.js